import { IELTSLevel } from './types';

/**
 * IELTS 等级详细描述
 */
export const IELTS_LEVEL_DESCRIPTIONS: Record<
  IELTSLevel,
  {
    name: string;
    cefrEquivalent: string;
    description: string;
    canDo: string[];
  }
> = {
  [IELTSLevel.Band9]: {
    name: '专家级',
    cefrEquivalent: 'C2',
    description: '英语接近母语者水平，运用自如、准确、流利并能完全理解语言。',
    canDo: [
      '完全理解英语，语言能力接近母语者',
      '能够自如、准确地表达复杂的思想和观点',
      '在任何场合都能流利地进行交流',
      '能准确理解各种复杂文本',
    ],
  },
  [IELTSLevel.Band85]: {
    name: '接近专家级',
    cefrEquivalent: 'C2',
    description: '偶尔出现不恰当或不准确的表达，但能很好地处理复杂的详细论证。',
    canDo: [
      '偶尔出现不恰当的表达，但整体非常流利',
      '能够很好地处理复杂的详细论证',
      '在绝大多数情况下能够准确表达',
    ],
  },
  [IELTSLevel.Band8]: {
    name: '高级',
    cefrEquivalent: 'C1',
    description: '能够自如、准确、流利地运用英语，偶尔出现不恰当的表达，但能很好地处理复杂的详细论证。',
    canDo: [
      '自如地运用英语，表达准确、流利',
      '偶尔出现不恰当或不准确的表达',
      '能够很好地处理复杂的详细论证',
      '理解复杂文本的主旨和细节',
    ],
  },
  [IELTSLevel.Band75]: {
    name: '中高级',
    cefrEquivalent: 'C1',
    description: '能够很好地掌握英语，偶尔出现不准确、不恰当和不理解的表达，但在一般领域内能够很好地处理复杂语言。',
    canDo: [
      '很好地掌握英语',
      '偶尔出现不准确或不恰当的表达',
      '在一般领域内能够很好地处理复杂语言',
    ],
  },
  [IELTSLevel.Band7]: {
    name: '良好',
    cefrEquivalent: 'C1',
    description: '能够掌握英语，偶尔出现不准确、不恰当和不理解的表达，但在一般领域内能够有效地运用英语。',
    canDo: [
      '掌握英语，在一般领域内能够有效运用',
      '偶尔出现不准确或不恰当的表达',
      '理解复杂语言，对详细论证能进行一定的推理',
    ],
  },
  [IELTSLevel.Band65]: {
    name: '中高级偏上',
    cefrEquivalent: 'B2',
    description: '能够较为有效地掌握英语，尽管出现一些不准确、不恰当和不理解的表达，但能在自己的领域内使用并理解相当复杂的语言。',
    canDo: [
      '较为有效地掌握英语',
      '在自己的领域内使用并理解相当复杂的语言',
      '出现一些不准确或不恰当的表达',
    ],
  },
  [IELTSLevel.Band6]: {
    name: '合格',
    cefrEquivalent: 'B2',
    description: '能够较为有效地掌握英语，尽管出现一些不准确、不恰当和不理解的表达，但通常能在自己的领域内使用并理解相当复杂的语言。',
    canDo: [
      '能够有效但有时不准确地运用英语',
      '通常能理解复杂语言',
      '在自己的领域内能使用相当复杂的语言',
    ],
  },
  [IELTSLevel.Band55]: {
    name: '中级偏上',
    cefrEquivalent: 'B1/B2',
    description: '能够部分掌握英语，在许多情况下能应对全面理解，尽管可能出现一些错误。',
    canDo: [
      '部分掌握英语',
      '在许多情况下能应对全面理解',
      '可能出现一些错误',
    ],
  },
  [IELTSLevel.Band5]: {
    name: '中级',
    cefrEquivalent: 'B1',
    description: '能够部分掌握英语，在大多数情况下能应对全面理解，尽管可能出现许多错误。',
    canDo: [
      '部分掌握英语',
      '在大多数情况下能全面理解总体含义',
      '可能犯许多错误',
    ],
  },
  [IELTSLevel.Band45]: {
    name: '基础偏上',
    cefrEquivalent: 'B1',
    description: '只能部分应对语言情况，在熟悉的情况下理解大意，虽然经常遇到问题。',
    canDo: [
      '部分应对语言情况',
      '在熟悉的情况下理解大意',
      '经常遇到问题',
    ],
  },
  [IELTSLevel.Band4]: {
    name: '基础',
    cefrEquivalent: 'B1',
    description: '只能在熟悉的情况下应对全面理解，在理解表达和频繁出现问题的情况下有困难。',
    canDo: [
      '在熟悉的情况下进行基本交流',
      '理解简单、直接的信息',
      '频繁遇到问题',
    ],
  },
  [IELTSLevel.Band35]: {
    name: '基础偏下',
    cefrEquivalent: 'A2',
    description: '只能在非常熟悉的情况下进行基本交流，理解简单信息，频繁出现表达和理解问题。',
    canDo: [
      '在非常熟悉的情况下进行基本交流',
      '理解简单信息',
      '频繁出现表达和理解问题',
    ],
  },
  [IELTSLevel.Band3]: {
    name: '有限',
    cefrEquivalent: 'A2',
    description: '只能理解非常熟悉的情况下的口语，在理解表达方面频繁出现问题。',
    canDo: [
      '理解非常熟悉情况下的基本意思',
      '频繁出现理解和表达问题',
      '能进行最简单的交流',
    ],
  },
  [IELTSLevel.Band25]: {
    name: '非常有限',
    cefrEquivalent: 'A1/A2',
    description: '几乎无法进行交流，除了非常熟悉的情况，无法在真实语境中使用英语。',
    canDo: [
      '几乎无法进行交流',
      '在非常熟悉的情况下可能理解基本意思',
      '无法在真实语境中使用英语',
    ],
  },
  [IELTSLevel.Band2]: {
    name: '间歇性',
    cefrEquivalent: 'A1',
    description: '真正不能进行交流，除了使用一些孤立的单词或短语满足即时需求外，无法在真实语境中使用英语。',
    canDo: [
      '真正不能进行交流',
      '只能使用一些孤立的单词或短语',
      '满足即时需求',
    ],
  },
  [IELTSLevel.Band15]: {
    name: '非常有限',
    cefrEquivalent: 'A1',
    description: '几乎不能交流，只能理解极少量的英语。',
    canDo: [
      '几乎不能交流',
      '理解极少量的英语',
    ],
  },
  [IELTSLevel.Band1]: {
    name: '无能力',
    cefrEquivalent: 'A0',
    description: '除了能使用一些孤立的单词外，没有能力使用英语。',
    canDo: [
      '没有能力使用英语',
      '只能使用一些孤立的单词',
    ],
  },
  [IELTSLevel.Band05]: {
    name: '几乎无能力',
    cefrEquivalent: 'A0',
    description: '几乎不能使用英语，可能只能使用个别单词。',
    canDo: [
      '几乎不能使用英语',
    ],
  },
  [IELTSLevel.Band0]: {
    name: '未参加考试',
    cefrEquivalent: 'N/A',
    description: '未能提供任何可评估的信息。',
    canDo: [],
  },
};

/**
 * 获取等级描述
 */
export function getLevelDescription(level: IELTSLevel) {
  return IELTS_LEVEL_DESCRIPTIONS[level];
}

/**
 * 获取下一个等级
 */
export function getNextLevel(currentLevel: IELTSLevel): IELTSLevel | null {
  const levels = Object.values(IELTSLevel);
  const currentIndex = levels.indexOf(currentLevel);
  if (currentIndex > 0) {
    return levels[currentIndex - 1]; // 0 is last in array, 9 is first
  }
  return null;
}

/**
 * 比较两个等级
 * 返回 -1 如果 a < b，0 如果 a = b，1 如果 a > b
 */
export function compareLevels(a: IELTSLevel, b: IELTSLevel): number {
  const levels = Object.values(IELTSLevel);
  const indexA = levels.indexOf(a);
  const indexB = levels.indexOf(b);
  return Math.sign(indexB - indexA); // 9 (high) > 0 (low)
}
